// Region entries carry a unique `code` (persisted selection) and the i18n
// `locale` they load. Locale codes mirror the Lokalise project (underscored,
// region-suffixed). Single shared source of truth for both the header and
// footer language selectors — add/remove a region here and both pick it up
// automatically. When adding a new locale, also register its resources in
// ./config.js so i18next can resolve it (otherwise it silently falls back
// to English).
export const LANGUAGE_GROUPS = [
	{
		label: "MAIN",
		options: [
			{ code: "us", locale: "en", urlLang: "en_US", label: "US (English)" },
			{ code: "ca", locale: "en", urlLang: "en_CA", label: "Canada (English)" },
			{ code: "uk", locale: "en", urlLang: "en_GB", label: "UK (English)" },
			{ code: "sg", locale: "en", urlLang: "en_SG", label: "Singapore (English)" },
			{ code: "hk", locale: "zh_HK", urlLang: "zh_HK", label: "Hong Kong (Traditional Chinese)" },
		],
	},
	{
		label: "EU",
		options: [
			{ code: "de", locale: "de", urlLang: "de_DE", label: "Germany" },
			{ code: "fr", locale: "fr", urlLang: "fr_FR", label: "France" },
			{ code: "es", locale: "es", urlLang: "es_ES", label: "Spain" },
			{ code: "it", locale: "it", urlLang: "it_IT", label: "Italy" },
			{ code: "ch", locale: "de_CH", urlLang: "de_CH", label: "Switzerland" },
			{ code: "nl", locale: "nl_NL", urlLang: "nl_NL", label: "Netherlands/Belgium" },
		],
	},
	{
		label: "ASIA",
		options: [
			{ code: "jp", locale: "ja_JP", urlLang: "ja_JP", label: "Japan" },
			{ code: "kr", locale: "ko_KR", urlLang: "ko_KR", label: "South Korea" },
		],
	},
]

export const LANGUAGES = LANGUAGE_GROUPS.flatMap((group) => group.options)

export const DEFAULT_REGION = "us"
export const DEFAULT_LOCALE = "en"
export const STORAGE_KEY = "bb_selected_locale"
export const LANG_PARAM = "lang"
export const IN_PLAY_KEY = "bb_lang_in_url"
